export const pulseFAQ = {
  items: [
    {
      question: "Can Project Pulse manage multiple projects?",
      answer:
        "Yes, you can seamlessly manage multiple customers and projects in one dashboard. It allows you to track individual project health, billing types, and status updates simultaneously.",
    },
    {
      question: "Is timesheet tracking mandatory?",
      answer:
        "It is recommended to drive the live KPI engine. Daily logging ensures that project progress and budget consumption are updated automatically in real-time.",
    },
    {
      question: "Can permissions be customized?",
      answer:
        "Yes, the platform uses Role-Based Access Control (RBAC). It ensures that users only see and edit data relevant to their specific role, from Admin to Resource.",
    },
    {
      question: "Does it support task hierarchies?",
      answer:
        "Absolutely. You can break down complex projects into Phases, Task Lists, Tasks, and Sub-tasks for granular control and better execution.",
    },
    {
      question: "Can managers monitor resource utilization?",
      answer:
        "Yes, managers get a clear view of resource hours and task assignments. This helps in balancing workloads and ensuring team productivity across all projects.",
    },
    {
      question: "Is Project Pulse suitable for remote teams?",
      answer:
        "Yes, it is a cloud-based platform designed for global collaboration. Remote teams can update tasks and log time from anywhere, keeping everyone in sync.",
    },
  ],
};

export const goatAppFAQ = {
  items: [
    {
      question: "Is GOATAPP available in Tamil?",
      answer: "Yes. GOATAPP supports multiple regional languages.",
    },
    {
      question: "Can I use the app offline?",
      answer: "Yes. Data syncs automatically once internet is available.",
    },
    {
      question: "Can I track vaccines?",
      answer: "Yes. Automated reminders help farmers never miss schedules.",
    },
    {
      question: "Is this suitable for large farms?",
      answer: "Yes. GOATAPP scales from small farms to large herd operations.",
    },
    {
      question: "Do you provide setup support?",
      answer: "Yes. Our team helps with on boarding and training.",
    },
  ],
};

export const meatAppFAQ = {
  items: [
    {
      question: "Can Customers track orders live?",
      answer:
        "Yes. Customers receive live order status updates and delivery tracking.",
    },
    {
      question: "Does the platform support offline shop billing?",
      answer:
        "Yes. Shop staff can create walk-in orders and generate bills instantly.",
    },
    {
      question: "Which Payment methods are supported?",
      answer: "Cash, UPI, Credit Card, and Debit Card payments are supported.",
    },
    {
      question: "Can I manage multiple branches?",
      answer: "Yes. The admin panel supports multi-branch operations.",
    },
    {
      question: "Is Inventory Updated in real-time?",
      answer: "Yes. Product stock updates instantly across all platforms.",
    },
  ],
};
export const finbookFAQ = {
  items: [
    {
      question: "Is Finbook GST-compliant?",
      answer:
        "Yes, Finbook is 100% GST-compliant. You can generate GST invoices, file returns, and manage e-invoicing with ease.",
    },
    {
      question: "Can I use Finbook on both desktop and mobile?",
      answer:
        "Absolutely! Finbook is available in both desktop and cloud versions. You can access it from your computer, tablet, or mobile device.",
    },
    {
      question: "Do I need accounting knowledge to use Finbook?",
      answer:
        "Not at all. Finbook is designed for business owners and staff with no prior accounting experience. It's simple, intuitive, and user-friendly.",
    },
    {
      question: "Is my data safe with Finbook?",
      answer:
        "Yes. Your data is encrypted and stored securely with enterprise-grade protection on our cloud servers.",
    },
    {
      question: "Can I manage inventory with Finbook?",
      answer:
        "Yes, you can track stock levels, batches, expiry dates, warehouses, and more with our advanced inventory management system.",
    },
    {
      question: "Does Finbook support multi-user access?",
      answer:
        "Yes, you can create multiple users with role-based access, allowing better team collaboration and control.",
    },
    {
      question: "Is there a free trial available?",
      answer:
        "Yes, you can try Finbook free for 7 days, no credit card required.",
    },
    {
      question: "Can I migrate from my old software to Finbook?",
      answer:
        "Yes, our team will help you migrate your data from existing software or Excel sheets with minimal effort.",
    },
  ],
};

export const crmFAQ = {
  items: [
    {
      question: "What is GSUS CRM?",
      answer:
        "GSUS CRM is a customer relationship management tool that helps you manage leads, sales, customer interactions, and team collaboration — all in one place.",
    },
    {
      question: "Is GSUS CRM suitable for small businesses?",
      answer:
        "Yes! GSUS CRM is designed to support small to medium businesses with easy-to-use tools and affordable pricing.",
    },
    {
      question: "Can I use GSUS CRM on mobile?",
      answer:
        "Absolutely. GSUS CRM is fully mobile-optimized so you can manage your business on the go",
    },
    {
      question: "Does it integrate with other tools?",
      answer:
        "Yes, GSUS CRM integrates with popular tools like Gmail, Outlook, WhatsApp, ERP systems, e-commerce platforms, and more.",
    },
    {
      question: "Is my data safe with GSUS CRM?",
      answer:
        "Yes. We use enterprise-grade security protocols to ensure your business and customer data is always protected.",
    },
  ],
};

export const erpFAQ = {
  items: [
    {
      question: "What is Invex ERP?",
      answer:
        " Invex ERP is an enterprise resource planning software solution designed to help businesses integrate and streamline their operations — from manufacturing, inventory, sales, finance to other core modules.",
    },
    {
      question: "Is Invex ERP suitable for small to mid-sized companies?",
      answer:
        " Yes — Invex ERP is built to scale and is suitable for small and mid-sized manufacturers and service businesses.",
    },
    {
      question:
        "Can Invex ERP be customized to fit my industry/business process?",
      answer:
        "Yes. The software can be tailored to your industry-specific needs and workflows, so you don’t have to adapt your business to rigid software constraints.",
    },
    {
      question: "What is the typical implementation time?",
      answer:
        " Implementation generally takes several months, depending on the complexity and scale of your operations.",
    },
    {
      question: "What support do I get after deployment?",
      answer:
        " We provide ongoing support, including troubleshooting, updates, training, and assistance to ensure your ERP system continues to run smoothly.",
    },
    {
      question: "How much does Invex ERP cost?",
      answer:
        " The cost depends on your requirements — number of users, modules needed, customizations, and deployment model. We offer flexible pricing tailored to your budget.",
    },
    {
      question: "How do I choose the right ERP system?",
      answer:
        "We assist by evaluating your current systems, processes, pain points, and goals — then recommend an ERP configuration that best fits your needs.",
    },
  ],
};

export const homeFAQ = {
  items: [
    {
      question: "What are ERP services, and how do they benefit my business?",
      answer:
        "We offer ERP implementation (SAP, Microsoft Dynamics), web/app development, AI, cloud, and digital solutions for businesses.",
    },
    {
      question: "How long does it take to implement an ERP system?",
      answer:
        "The implementation timeline depends on your business size and requirements. Typically, ERP deployment can take anywhere from 3 to 6 months, including planning, customization, testing, and training.",
    },
    {
      question: "Can ERP solutions be customized for my business?",
      answer:
        "Yes, our ERP systems are fully customizable to match your organization’s workflow, industry standards, and specific operational needs.",
    },
    {
      question:
        "What kind of ongoing support is provided after ERP implementation?",
      answer:
        "We provide continuous post-implementation support, including system updates, performance monitoring, troubleshooting, and user training to ensure smooth operation.",
    },
    {
      question: "How does ERP improve business efficiency?",
      answer:
        "ERP integrates all key business processes—finance, HR, supply chain, inventory, and more—into a single platform, reducing manual work, eliminating data duplication, and improving overall efficiency.",
    },
    {
      question:
        "Is an ERP solution suitable for small and mid-sized businesses?",
      answer:
        "Absolutely. Modern ERP systems are scalable and cost-effective, making them ideal for small and mid-sized businesses to automate processes and grow efficiently.",
    },
    {
      question: "Can ERP systems integrate with my existing business software?",
      answer:
        "Yes, our ERP solutions can seamlessly integrate with your existing applications such as CRM, accounting, or HR systems to ensure smooth data flow across platforms.",
    },
  ],
};
export const consultingFAQ = {
  items: [
    {
      question: "How do I know if Odoo is the right fit for my business?",
      answer:
        "We assess your workflows, existing systems, business goals, and operational gaps to see where Odoo fits - and where it may not.",
    },
    {
      question: "Will you recommend only the Odoo modules we actually need?",
      answer:
        "Yes. Module recommendations are based on your business processes, so you don't end up paying for features your teams won't use.",
    },
    {
      question: "Can you assess an Odoo setup that isn't working properly?",
      answer:
        "Yes. We review existing configurations, customisations, and workflows to identify what is causing issues and what needs to change.",
    },
    {
      question: "How do you decide whether a process needs customisation?",
      answer:
        "We first check what Odoo can handle through standard features and configuration. Customisation is considered only when there's a genuine process gap.",
    },
    {
      question: " Will I get a clear cost and implementation timeline?",
      answer:
        "Yes. Your roadmap considers modules, integrations, customisation, data migration, and rollout phases to give you a more realistic view of the project",
    },
    {
      question: "What do I get from the GSUS Odoo Fit Assessment?",
      answer:
        "You get a practical roadmap covering solution fit, process gaps, module requirements, implementation priorities, and the recommended next steps.",
    },
  ],
};
export const odooerpFAQ = {
  items: [
    {
      question: "How long does an Odoo implementation usually take?",
      answer:
        "A typical implementation takes around 90 days, depending on the number of modules, integrations, customisation, and data migration involved.",
    },
    {
      question: "Do you customise Odoo for every business?",
      answer:
        "Only where necessary. We first use Odoo's standard features and configuration, then add custom development for processes that genuinely require it.",
    },
    {
      question: "Can you migrate our existing ERP data to Odoo?",
      answer:
        "Yes. We clean, map, validate, and test your legacy data before migration, including data from systems such as SAP, NetSuite, QuickBooks, or older Odoo versions.",
    },
    {
      question: "How do we know the Odoo system will work before going live?",
      answer:
        "Your team tests real business transactions in a sandbox during UAT. Issues are addressed and the system is signed off before the final go-live.",
    },
    {
      question: "What happens after our Odoo system goes live?",
      answer:
        "GSUS provides go-live support, user training, and a 30-day hypercare period to help your teams resolve early issues and settle into the new system.",
    },
    {
      question: "Do we need a full Odoo implementation?",
      answer:
        "Not necessarily. If you only need a few modules or have simple workflows, a smaller configuration engagement may be enough. We recommend the approach that fits your actual requirements.",
    },
  ],
};
export const customizeFAQ = {
  items: [
    {
      question: "When does my business need Odoo customization?",
      answer:
        "When standard Odoo features cannot support a critical business process. We check configuration options first before recommending custom development.",
    },
    {
      question: "Can GSUS customize an existing Odoo system?",
      answer:
        "Yes. We can improve existing Odoo setups with custom modules, workflows, reports, and business logic without disrupting core operations.",
    },
    {
      question: "Will customization affect future Odoo upgrades?",
      answer:
        "Properly built customization should not. We keep custom features in separate modules instead of changing Odoo core code, making upgrades easier.",
    },
    {
      question: "Can Odoo be customized without changing existing processes?",
      answer:
        "Yes. Where practical, we adapt Odoo to fit important business workflows instead of forcing teams to completely change how they work.",
    },
    {
      question: "How do you decide between customization and configuration?",
      answer:
        "We review requirements first, then identify what Odoo can handle through standard configuration and what needs development. This helps control cost and avoid unnecessary customization.",
    },
    {
      question: "Can custom Odoo modules grow with business needs?",
      answer:
        "Yes. We build custom modules with scalability, documentation, and maintainability in mind, allowing them to evolve as business requirements change.",
    },
  ],
};

export const integrationFAQ = {
  items: [
    {
      question: "What systems can you integrate with Odoo?",
      answer:
        "We connect Odoo with e-commerce platforms, payment gateways, banks, shipping carriers, communication tools, biometric devices, IoT systems, and third-party business software.",
    },
    {
      question: "Can Odoo integrations sync data in both directions?",
      answer:
        "Yes. We build bi-directional integrations where required, so updates in Odoo can reflect in connected systems and external updates can flow back into Odoo automatically.",
    },
    {
      question:
        "Can you integrate our existing or custom-built software with Odoo?",
      answer:
        "Yes. If your system provides an API or another reliable integration method, we can assess the data flow and build a suitable connection around your business process.",
    },
    {
      question:
        "How do you make sure an integration doesn't break when an API changes?",
      answer:
        "Integrations are built with monitoring, alerting, and versioning where appropriate, helping your team identify failures quickly when third-party platforms change.",
    },
    {
      question: "How long does an Odoo integration take?",
      answer:
        "The timeline depends on the systems involved, data complexity, and workflow requirements. After reviewing your setup, we provide a clear integration scope and realistic timeline.",
    },
    {
      question:
        "What makes GSUS different from a standard integration provider?",
      answer:
        "We start by mapping your business workflow before choosing the integration approach. This helps us connect systems around how your business actually operates, rather than simply moving data between platforms.",
    },
  ],
};

export const migrationFAQ = {
  items: [
    {
      question: "What data can you migrate into Odoo?",
      answer:
        "We migrate master, transactional, financial, inventory, and historical data, including customers, products, invoices, payments, opening balances, and custom fields.",
    },
    {
      question:
        "Can you migrate data from Tally, SAP, Excel, or an old Odoo database?",
      answer:
        "Yes. We handle migrations from Tally, SAP, spreadsheets, and existing Odoo databases, with the mapping approach adapted to each source system.",
    },
    {
      question: "How do you make sure data isn't lost during migration?",
      answer:
        "The migration is first performed in a sandbox, followed by record counts, financial checks, relationship validation, and reconciliation before anything moves to production.",
    },
    {
      question: "Will you clean our existing data before moving it to Odoo?",
      answer:
        "Yes. We identify duplicates, inconsistent formats, outdated records, and other data issues during the cleansing and standardization stage.",
    },
    {
      question: "How long does an Odoo data migration take?",
      answer:
        "It depends on the volume, source systems, data quality, and migration scope. After the initial audit, we provide a realistic timeline based on what actually needs to be migrated.",
    },
    {
      question: "Does GSUS provide support after the migration?",
      answer:
        "Yes. We provide post-migration support to help resolve migration-related issues and ensure your team can work confidently with the new Odoo database.",
    },
  ],
};

export const websiteFAQ = {
  items: [
    {
      question:
        "Can you build an Odoo website from scratch or customize an existing one?",
      answer:
        "Yes. We can build a new Odoo website or improve an existing one, including its design, e-commerce features, customer journeys, and business workflows.",
    },
    {
      question:
        "Can my Odoo website connect directly with inventory, sales, and accounting?",
      answer:
        "Yes. Odoo can connect your website with sales, inventory, CRM, invoicing, and other business functions, keeping key information in one connected system.",
    },
    {
      question: "Can you migrate our existing e-commerce store to Odoo?",
      answer:
        "Yes. GSUS can migrate products, customers, orders, and relevant store data from platforms such as WooCommerce, Magento, or other existing systems.",
    },
    {
      question: "Can you integrate payment gateways and shipping providers?",
      answer:
        "Yes. We can connect payment gateways such as Razorpay, Stripe, and PayPal, along with shipping and delivery services based on your business requirements.",
    },
    {
      question: "Will we be able to manage the website ourselves after launch?",
      answer:
        "Yes. We configure the Odoo website so your team can manage products, content, orders, and other day-to-day updates without depending on developers for every change.",
    },
    {
      question: "Can the Odoo website scale as our business grows?",
      answer:
        "Yes. Your website can grow alongside Odoo modules such as POS, CRM, manufacturing, accounting, and multi-warehouse operations without needing to rebuild the entire commerce setup.",
    },
  ],
};
export const cloudFAQ = {
  items: [
    {
      question: "Will custom Odoo modules work on your hosting environment?",
      answer:
        "Yes. We support custom modules, third-party apps, integrations, and Git-based deployment workflows across development, staging, and production.",
    },
    {
      question: "What happens when an Odoo update breaks a customisation?",
      answer:
        "Changes can be tested in an isolated staging environment first, so compatibility issues are identified before anything reaches production.",
    },
    {
      question: "Can you handle Odoo performance issues as our database grows?",
      answer:
        "Yes. We monitor server load, response times, PostgreSQL performance, and database health, then optimise the environment as usage increases.",
    },
    {
      question:
        "How quickly can our Odoo environment be restored after a failure?",
      answer:
        "Backups are automated and versioned, with recovery procedures designed to restore the environment quickly when something goes wrong",
    },
    {
      question: "Can we move our Odoo environment elsewhere later?",
      answer:
        "Yes. GSUS does not lock you into its infrastructure. You retain access to your environment and can move your Odoo setup when required.",
    },
  ],
};
export const trainingFAQ = {
  items: [
    {
      question: "Can you train different teams based on their roles in Odoo?",
      answer:
        "Yes. Training is structured around each role and department, so Finance, Sales, Warehouse, HR, and administrators learn the workflows they actually use.",
    },
    {
      question: "Do you provide training on our customized Odoo setup?",
      answer:
        "Yes. GSUS can build training around your configured Odoo environment, including custom workflows, approval rules, terminology, and modules your team uses.",
    },
    {
      question: "Is Odoo training available for both new and existing users?",
      answer:
        "Yes. We train new users from the basics and can also retrain existing teams when processes change, new modules are introduced, or adoption is low.",
    },
    {
      question: " Can Odoo training be conducted online or at our office?",
      answer:
        "Yes. Training is available through on-site, live online, self-paced, and hybrid formats depending on your team's location and requirements.",
    },
    {
      question: "Do you provide training after an Odoo implementation?",
      answer:
        "Yes. Post-implementation training helps users understand the configured system and apply the correct workflows from day one, with follow-up support for questions that arise during actual usage.",
    },
    {
      question: "Can our internal team become Odoo trainers?",
      answer:
        "Yes. Our train-the-trainer program prepares selected employees to support internal users and onboard new team members without depending on external consultants for every basic question.",
    },
  ],
};

export const supportFAQ = {
  items: [
    {
      question:
        "Our Odoo was implemented years ago. Can GSUS still take over the support?",
      answer:
        "Yes. We can review your current Odoo version, modules, customizations, configurations, integrations, and known issues before defining the right support approach.",
    },
    {
      question: "What if our Odoo issue is caused by an old customization?",
      answer:
        "We first review the issue and identify whether it is related to the existing customization, configuration, or standard Odoo functionality. Work outside the AMC scope can be handled separately as a Change Request.",
    },
    {
      question: "Can we upgrade from Silver to Gold or Platinum later?",
      answer:
        "Yes. Your support requirements can be reviewed at renewal, and the AMC plan can be adjusted based on how your business and Odoo usage have evolved.",
    },
    {
      question: "What happens when a request falls outside our AMC scope?",
      answer:
        "We define it clearly before the work begins. A separate Change Request can be prepared with the scope, timeline, and cost estimate.",
    },
    {
      question:
        "Do we need an AMC if our Odoo system is currently running without issues?",
      answer:
        "That is often the best time to have one. Ongoing support helps manage bugs, errors, user issues, process changes, and system requirements before they start affecting daily operations.",
    },
  ],
};

export const upgradeFAQ = {
  items: [
    {
      question: "How do I know if my Odoo version needs an upgrade?",
      answer:
        "If your version is no longer supported, you're facing compatibility issues, or your integrations and custom modules are becoming difficult to maintain, an upgrade may be worth assessing.",
    },
    {
      question:
        "Can you upgrade Odoo without losing our existing data and customizations?",
      answer:
        "Yes. We migrate and validate your data, while custom modules and workflows are assessed and reworked for the target version rather than simply carried forward unchanged.",
    },
    {
      question: "What happens if our Odoo instance is heavily customised?",
      answer:
        "That's not a problem. GSUS audits your custom modules, Studio features, workflows, and integrations to identify what can migrate directly and what needs refactoring or rebuilding.",
    },
    {
      question: "Can we keep using Odoo while the upgrade is being prepared?",
      answer:
        "Yes. The upgrade is first performed in an isolated staging environment, so your production system can continue running while the new version is tested and validated",
    },
    {
      question: "How long does an Odoo upgrade take?",
      answer:
        "The timeline depends on your version gap, customisations, integrations, data volume, and testing requirements. After the assessment, we provide a clear upgrade roadmap and realistic timeline.",
    },
    {
      question: "What support do we get after the Odoo upgrade?",
      answer:
        "The team stays involved after go-live to monitor the upgraded system, resolve issues, and make sure your everyday workflows continue working as expected.",
    },
  ],
};

export const businessFAQ = {
  items: [
    {
      question: "What Odoo processes can be automated?",
      answer:
        "Common examples include approvals, notifications, task assignments, order workflows, invoice reminders, stock alerts, reporting, and customer communications.",
    },
    {
      question: "Can you automate our existing Odoo workflows?",
      answer:
        "Yes. We first review how your current workflows operate, including manual steps and workarounds, then identify where automation can improve the process.",
    },
    {
      question:
        "Will automation remove the need for employees to review important decisions?",
      answer:
        "Not necessarily. We design automation around your business rules, keeping human approval or decision points where they are genuinely required.",
    },
    {
      question: "Do you use Odoo's built-in automation features?",
      answer:
        "Yes. GSUS prioritizes Odoo's native capabilities where they fit, using custom development only when the requirement cannot be handled effectively through standard tools.",
    },
    {
      question:
        "How do you decide whether an automation is worth implementing?",
      answer:
        "We look at the time saved, errors reduced, transaction volume, and operational impact. The goal is to automate processes that create measurable business value.",
    },
    {
      question: "Can existing automations be reviewed and improved?",
      answer:
        "Yes. We can audit existing automated actions, workflows, scheduled activities, and custom logic to identify what is working, what is causing issues, and where further improvement is possible.",
    },
  ],
};

export const telecomFAQ = {
  items: [
    {
      question: "Can Odoo manage the complete telecom customer lifecycle?",
      answer:
        "Yes. Odoo can connect sales, subscriber management, service activation, field service, support, asset tracking, billing, and finance within one connected workflow.",
    },
    {
      question: "Can Odoo handle telecom field service operations?",
      answer:
        "Yes. Teams can manage technician scheduling, work orders, parts availability, service visits, time tracking, and SLA-related activities from one system.",
    },
    {
      question: "Can Odoo manage subscription and recurring telecom billing?",
      answer:
        "Yes. Odoo can support subscription-based, usage-based, or hybrid billing workflows, depending on your business model and billing requirements.",
    },
    {
      question:
        "Can we track telecom assets such as routers, modems, and equipment?",
      answer:
        "Yes. Equipment can be tracked across purchasing, warehouse, installation, service, and end-of-life stages, giving your team better visibility into asset history.",
    },
    {
      question: "Can Odoo connect our existing telecom systems and tools?",
      answer:
        "Yes. We can assess your existing applications, APIs, data, and workflows and determine where integrations are needed to create a connected operational flow.",
    },
    {
      question:
        "Can GSUS configure Odoo for different telecom business models?",
      answer:
        "Yes. We can tailor the solution for ISPs, broadband and cable providers, mobile operators, and B2B or managed service providers based on their operational workflows.",
    },
  ],
};

export const mobileFAQ = {
  items: [
    {
      question: "Can you build a mobile app specifically for our Odoo setup?",
      answer:
        "Yes. We build the app around your Odoo modules, customizations, workflows, user roles, and the way your teams work in the field.",
    },
    {
      question: "Can the mobile app work when there is no internet connection?",
      answer:
        "Yes. We can build offline-first functionality so users can capture relevant information without connectivity and sync it with Odoo once the connection is restored.",
    },
    {
      question: "Which Odoo modules can be connected to a mobile app?",
      answer:
        "The app can connect with modules such as Sales, CRM, Inventory, Field Service, Helpdesk, HR, Accounting, and Manufacturing, depending on your requirements.",
    },
    {
      question: "Can different employees see different information in the app?",
      answer:
        "Yes. Role-based access can be configured so sales reps, drivers, technicians, managers, and customers only access the information and actions relevant to them.",
    },
    {
      question: "Can GSUS build both Android and iOS apps for Odoo?",
      answer:
        "Yes. We develop native or hybrid mobile applications for Android and iOS, based on your requirements, Odoo environment, and expected usage.",
    },
    {
      question:
        "Can the mobile app use features like barcode scanning and push notifications?",
      answer:
        "Yes. Mobile features such as barcode, QR and RFID scanning, push notifications, e-signatures, and location-based workflows can be connected to relevant Odoo processes.",
    },
  ],
};

export const retailFAQ = {
  items: [
    {
      question: "Can Odoo manage multiple retail stores and warehouses?",
      answer:
        "Yes. Odoo can manage multiple locations, warehouses, stock transfers, pricing, purchasing, and reporting from one connected system.",
    },
    {
      question: "Can Odoo connect our POS, inventory, and accounting?",
      answer:
        "Yes. Sales made through POS can update inventory and financial records automatically, reducing duplicate entries and keeping your numbers aligned.",
    },
    {
      question: "Can Odoo handle both retail and wholesale operations?",
      answer:
        "Yes. Odoo supports retail POS alongside wholesale requirements such as bulk pricing, customer-specific rates, credit terms, purchasing, and distribution workflows.",
    },
    {
      question:
        "Can our online store and physical stores share the same inventory?",
      answer:
        "Yes. Odoo can connect e-commerce and physical stores so orders, stock levels, and product information stay synchronized across channels.",
    },
    {
      question:
        "Can we migrate our existing products, customers, and pricing into Odoo?",
      answer:
        "Yes. We can migrate data from spreadsheets or existing systems, clean and structure it, and configure your catalog, pricing, suppliers, and customer records for Odoo.",
    },
    {
      question: "Can GSUS help us roll out Odoo store by store?",
      answer:
        "Yes. A phased rollout can start with one location or channel, allowing your team to validate the workflows and numbers before expanding Odoo across the rest of the business.",
    },
  ],
};
export const manufacturingFAQ = {
  items: [
    {
      question: "Can Odoo handle complex manufacturing processes?",
      answer:
        "Yes. Odoo can support discrete, process, mixed-mode, and engineer-to-order manufacturing, including BOMs, routings, work orders, quality, maintenance, inventory, and costing.",
    },
    {
      question:
        "Can Odoo connect production planning with inventory and procurement?",
      answer:
        "Yes. Production requirements can be connected with material availability and procurement, helping teams identify shortages earlier and keep purchasing aligned with production needs.",
    },
    {
      question:
        "Can you configure Odoo around our existing manufacturing processes?",
      answer:
        "Yes. We start by understanding your BOMs, routings, production methods, and workflows, then configure Odoo around the way your plant operates.",
    },
    {
      question: "Can Odoo track shop-floor activity in real time?",
      answer:
        "Yes. Teams can record work orders, production output, labour time, machine activity, scrap, and other shop-floor information directly in Odoo.",
    },
    {
      question: "Can Odoo manage manufacturing costing and profitability?",
      answer:
        "Yes. Odoo can bring together material, labour, and other production costs to give you a clearer view of product, job, and order profitability.",
    },
    {
      question:
        "Does GSUS support phased Odoo implementation for manufacturing?",
      answer:
        "Yes. We can roll out manufacturing functions in phases based on your operational priorities and risk tolerance, helping you improve the system without disrupting production.",
    },
  ],
};

export const healthcareFAQ = {
  items: [
    {
      question: "Can we migrate our existing patient and operational data? ",
      answer:
        "Yes. Existing patient, staff, inventory, financial, and other relevant records can be migrated through a structured process based on your current systems and data requirements. ",
    },
    {
      question: "Can different departments have different levels of access?",
      answer:
        "Yes. Role-based permissions allow administrators to control what users can view and manage based on their department, responsibilities, and access requirements. ",
    },
    {
      question: "Can we manage multiple clinics or healthcare facilities? ",
      answer:
        "Yes. Multiple locations can be managed through a connected system while maintaining appropriate visibility over patients, staff, inventory, billing, and operational performance. ",
    },
    {
      question: "Can the ERP be customised around our existing workflows?  ",
      answer:
        "Yes. Workflows, fields, approvals, reports, user roles, and other processes can be configured to match how your facility operates.",
    },
    {
      question:
        "Can it integrate with our existing healthcare and business systems?  ",
      answer:
        "Yes. The ERP can connect with supported payment, accounting, communication, laboratory, pharmacy, and other relevant systems based on your integration requirements. ",
    },
    {
      question: "How long does implementation take? ",
      answer:
        "Implementation depends on the number of locations, users, workflows, integrations, and data involved. A rollout plan can be created based on the specific requirements of your facility. ",
    },
    {
      question: "How is our healthcare data protected?  ",
      answer:
        "Access can be controlled through role-based permissions, with security measures such as encryption, backups, and audit trails helping protect sensitive operational and patient information. ",
    },
    {
      question:
        "Can we start with specific departments instead of implementing everything at once?  ",
      answer:
        "Yes. You can begin with priority areas such as appointments, patient management, inventory, billing, or finance and expand the system as your requirements grow. ",
    },
  ],
};

export const automativeFAQ = {
  items: [
    {
      question:
        "Can one system manage vehicle sales, workshop operations, spare parts, and finance? ",
      answer:
        "Yes. Odoo connects these functions through shared data, so a vehicle sale, repair job, parts movement, or invoice can update the relevant workflows without repeated manual entry.",
    },
    {
      question: "How does the system handle parts used during repair? ",
      answer:
        "Parts can be linked to the job card and recorded as they are consumed. This helps the workshop track repair costs while inventory levels update automatically. ",
    },
    {
      question: "Can we manage multiple branches from one Odoo system? ",
      answer:
        "Yes. You can manage dealerships, workshops, warehouses, and parts locations from one central platform while still tracking the performance and stock of each branch separately. ",
    },
    {
      question:
        "Can Odoo support automotive-specific requirements such as VINs, warranties, and job cards? ",
      answer:
        "Yes. Odoo can be configured and customised around automotive workflows, including VIN-based records, warranty processes, digital job cards, parts management, and other business-specific requirements. ",
    },
    {
      question:
        "Do we have to replace all our existing software to implement Odoo? ",
      answer:
        "No. Odoo can integrate with selected third-party systems, allowing your business to connect important workflows without replacing every existing application at once. ",
    },
  ],
};

export const constructionFAQ = {
  items: [
    {
      question: "Can Odoo manage multiple construction sites from one system? ",
      answer:
        "Yes. Odoo brings project progress, materials, procurement, resources, and costs from multiple sites into one central view. ",
    },
    {
      question: "How does Odoo handle changing material requirements on-site? ",
      answer:
        "Teams can check available stock, material movement, and purchase requirements before placing new orders, helping reduce both shortages and unnecessary purchases. ",
    },
    {
      question:
        "Can we customise approval workflows for construction projects? ",
      answer:
        "Yes. Approval flows can be configured based on project, department, purchase value, or responsible team, keeping critical requests moving without losing control. ",
    },
    {
      question: "Can we see project cost overruns before month-end? ",
      answer:
        "Yes. Project purchases, materials, timesheets, expenses, and other costs can be connected to project budgets, giving teams earlier visibility into cost movements. Yes. Odoo can be configured and customised around automotive workflows, including VIN-based records, warranty processes, digital job cards, parts management, and other business-specific requirements. ",
    },
    {
      question: "Do we need to replace our existing construction software? ",
      answer:
        "Not always. Odoo can integrate with selected tools already used for accounting, HR, communication, design, and reporting, depending on your existing setup. ",
    },
  ],
};

export const engineeringFAQ = {
  items: [
    {
      question:
        "Can GSUS manage the full engineering project lifecycle in Odoo?",
      answer:
        "Yes. GSUS can configure Odoo to manage projects from estimation and planning through resource allocation, execution, procurement, costing, billing, and project close-out.",
    },
    {
      question: "Can we track project costs against the budget in real time?",
      answer:
        "Yes. Project budgets can be connected with timesheets, expenses, purchases, and other project costs, giving your team a clearer view of planned versus actual spending.",
    },
    {
      question:
        "Can project managers see resource availability before assigning work?",
      answer:
        "Yes. Resource planning helps project managers see team capacity, existing commitments, skills, and availability before assigning people to new projects or tasks.",
    },
    {
      question:
        "Can we manage timesheets and bill clients from the same system?",
      answer:
        "Yes. Team members can record time against projects and tasks, while approved billable hours, expenses, or milestones can be used to prepare client invoices with less manual reconciliation.",
    },
    {
      question:
        "Can Odoo help us identify project profitability before the project ends?",
      answer:
        "Yes. GSUS can configure project profitability views using revenue, labour, expenses, procurement, and other relevant costs, allowing teams to monitor margins while there is still time to act.",
    },
    {
      question:
        "Can GSUS connect our existing engineering and business systems with Odoo?",
      answer:
        "Yes. GSUS can assess your existing accounting, ERP, communication, document, and other business systems and recommend the right integration or migration approach based on your project workflows.",
    },
  ],
};

export const serviceFAQ = {
  items: [
    {
      question: "Can GSUS support different types of service businesses?",
      answer:
        "Yes. GSUS can configure the system around consulting, field service, IT & MSP, marketing, healthcare, and other service-based workflows.",
    },
    {
      question:
        "Can we manage projects, field jobs, and recurring services in one system?",
      answer:
        "Yes. You can manage projects, tasks, field service, recurring contracts, scheduling, timesheets, and billing through one connected Odoo environment.",
    },
    {
      question: "Can our field team update jobs from the field?",
      answer:
        "Yes. Field teams can access assigned jobs, record time and parts, add notes or photos, capture signatures, and update job status while on-site.",
    },
    {
      question: "Can completed work flow directly into invoicing?",
      answer:
        "Yes. Logged hours, expenses, parts, and completed service activities can flow into invoicing, reducing manual re-entry and billing delays.",
    },
    {
      question: "Can we see which projects or clients are actually profitable?",
      answer:
        "Yes. GSUS can configure reporting around project costs, billable hours, expenses, revenue, and margins, giving you better visibility into profitability.",
    },
    {
      question:
        "What if our current processes are already built around spreadsheets or other tools?",
      answer:
        "GSUS can assess your existing workflows, data, and tools before implementation. We can then plan the right migration and integration approach without disrupting your daily operations.",
    },
  ],
};

export const agricultureFAQ = {
  items: [
    {
      question: "Can the ERP manage both crops and livestock? ",
      answer:
        "Yes. The platform can bring crop activities and livestock operations into one connected system, so teams don't need separate tools for each side of the business. ",
    },
    {
      question: " Can I track individual animals?",
      answer:
        "Yes. Individual animal records can include details such as breed, weight, health history, lineage, and other relevant operational information. ",
    },
    {
      question: "Can field staff use the system from mobile devices?",
      answer:
        "Yes. Field teams can access relevant information and record day-to-day activities from mobile devices, depending on the system configuration. ",
    },
    {
      question: "Does it work when there is no internet connection? ",
      answer:
        "If your implementation includes offline functionality, users can record relevant information without a connection and sync it when they are back online.",
    },
    {
      question: "Can I track feed, medicines, seeds, and other inventory?",
      answer:
        "Yes. Inventory can be organised around the materials your operation uses, including feed, seeds, medicines, equipment, and produce. ",
    },
    {
      question: "Can I see profit by crop, animal, farm, or season? ",
      answer:
        "The system can provide financial and operational reporting based on the tracking structure configured for your business. ",
    },
    {
      question: "Can it manage multiple farms or locations? ",
      answer:
        "Yes. A connected ERP can support multiple farms, locations, warehouses, or operating units from a central system. ",
    },
    {
      question:
        "Can the system connect with accounting and other business tools? ",
      answer:
        "Yes. Available integrations depend on the applications and systems your business currently uses.",
    },
    {
      question: "How long does implementation take? ",
      answer:
        "Implementation time depends on the size and complexity of your operation, the number of users, data migration requirements, and customisations.",
    },
  ],
};

export const logisticsFAQ = {
  items: [
    {
      question:
        "Do we have to switch everything at once, or can we start with one area? ",
      answer:
        "Most clients start with one or two areas - usually warehouse and inventory, or delivery and fleet - and expand once the data is flowing. You don't need to overhaul your whole operation on day one. ",
    },
    {
      question:
        "Will this work with the warehouse or fleet systems we already have? ",
      answer:
        "In most cases, yes. It's built to integrate with common WMS, accounting, and telematics systems rather than force a full replacement on day one. ",
    },
    {
      question: "How long does implementation take? ",
      answer:
        "A typical rollout for a single warehouse or fleet region takes 2–4 weeks, including data migration and staff onboarding. ",
    },
    {
      question: "Who actually uses this day to day?",
      answer:
        "Warehouse staff, dispatchers, drivers on mobile, customer service, billing, and operations leadership - each sees only the views relevant to their role. ",
    },
    {
      question: "What does it cost? ",
      answer:
        "Pricing depends on order volume, number of warehouses and vehicles, and which areas you need. Book a walkthrough and we'll scope it against your actual operation. ",
    },
  ],
};

export const foodFAQ = {
  items: [
    {
      question: "Do we have to replace our existing POS? ",
      answer:
        "No. Fareway is built to connect with most common POS setups, so your front-of-house stays the same while everything behind it gets connected. ",
    },
    {
      question:
        "We run several outlets under different brands  can it handle that? ",
      answer:
        "Yes. You can manage separate menus, stock, and P&Ls per outlet or brand, while still seeing the combined picture from one login. ",
    },
    {
      question: "How long does it take to go live? ",
      answer:
        "Most single-location businesses are live within a couple of weeks. Multi-location rollouts are typically staged outlet by outlet. ",
    },
    {
      question:
        "Is this only for restaurants, or does it work for distributors too? ",
      answer:
        "It's used across the F&B chain - restaurants, cafes, cloud kitchens, bars, and distributors all use the same core system, configured for how they operate. ",
    },
    {
      question: "What does it cost? ",
      answer:
        "Pricing depends on the number of outlets and modules you need. Book a walkthrough and we'll size it to your business, not the other way around. ",
    },
  ],
};

export const educationFAQ = {
  items: [
    {
      question:
        "Can we manage different courses and programs with separate workflows?",
      answer:
        "Yes. Admissions, fee structures, schedules, batches, and faculty assignments can be configured differently for each course or program. ",
    },
    {
      question:
        "Can our existing student and fee records be moved into the new system?",
      answer:
        "Yes. Existing student, admission, fee, and other relevant records can be migrated into the platform with a structured migration process. ",
    },
    {
      question: "Can parents and students access the system separately?  ",
      answer:
        "Yes. Separate access can be provided based on user roles, giving students, parents, faculty, and administrators access to relevant information.",
    },
    {
      question: "Can the system handle multiple campuses or training centres? ",
      answer:
        "Yes. You can manage multiple locations from one platform while maintaining separate visibility over students, fees, staff, and operations. ",
    },
    {
      question:
        "Can the platform work alongside our existing payment and communication tools? ",
      answer:
        "Yes. The system can integrate with payment gateways, SMS, email, and other relevant tools without requiring you to replace your entire existing setup. ",
    },
  ],
};

export const textileFAQ = {
  items: [
    {
      question: "Can Odoo handle textile manufacturing? ",
      answer:
        "Yes. It can manage spinning, weaving, knitting, dyeing, garment production, inventory, quality, costing, and job work. ",
    },
    {
      question: "Can we track yarn, fabric, rolls and lots? ",
      answer:
        "Yes. Track materials by lot, batch, roll, shade, GSM, width, and quantity. ",
    },
    {
      question: "Can we manage textile job work? ",
      answer:
        "Yes. Track material issues, processed quantity, shortages, rejections, and job-work charges. ",
    },
    {
      question: "Can we track wastage? ",
      answer:
        "Yes. Compare standard and actual consumption to identify wastage and process losses. ",
    },
    {
      question: "Can we calculate textile production costs? ",
      answer:
        "Yes. Connect material, processing, job work, and other costs to calculate actual order profitability. ",
    },
    {
      question: "Can GSUS customise Odoo for our textile process? ",
      answer:
        "Yes. We understand your workflow first, then configure and customise Odoo around your business. ",
    },
  ],
};
